import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import Comm from '../comm/comm';
import { toast } from 'react-toastify';
import ClipLoader from "react-spinners/ClipLoader";
import Tools from '../tools/tools';

const ModalSelectDocument = (props) => {
    var [sel, setSel] = useState("-1");
    var [documents, setDocuments] = useState(null);


    const fetchData = async () => {
        setDocuments(null);
        Comm.Instance().get(`document/GetAll?requestId=${props.requestId}`).then(result => {
            setDocuments(result.data);

        }).catch(error => Tools.ProcessError(error))
    };


    useEffect(() => {

        fetchData();
    }, []);

    const Attach = () => {

        props.closeFunc(documents.filter(x => x.documentId === sel)[0]);

    }
    if (!documents)
        return (
            <div className="container">
                <ClipLoader
                    size={150}
                    color={"#123abc"}
                    loading={!documents}
                />
            </div>
        );

    return (
        <Dialog header="Електронен оригинал" visible={props.display} style={{ width: '50vw' }} footer="" onHide={() => props.closeFunc(null)}>
            <p>
                <label>Файл</label>
                <select className="form-control" type="text" value={sel} onChange={(e) => setSel(e.target.value)}>
                    <option value="-1" key="-1"></option>
                    {
                        documents.map(i =>
                            <option value={i.documentId} key={i.documentId}>{i.title}</option>
                        )
                    }
                </select>

            </p>

            <button className="btn btn-primary" onClick={() => Attach()} disabled={sel === "-1"}>Прикачване</button>

        </Dialog>

    );
}


export default ModalSelectDocument;

